
import { useState, useEffect, useRef, MutableRefObject } from 'react';

/**
 * Hook that tracks whether an element is visible in the viewport
 * @param options Intersection Observer options
 * @returns [ref, isIntersecting] where ref is a callback ref and isIntersecting indicates if element is visible
 */
export function useIntersectionObserver(options = {}): [MutableRefObject<null>, boolean] {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, options);

    const currentElement = elementRef.current;

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [options]);

  return [elementRef, isIntersecting];
}
